import Vue from "vue";
import Vuex from "vuex";
import {getClassDetail, getOrganizationInfo} from "@/api/agency/agency";
import {heartBeat} from "@/api/common/api";
import {correctStatus} from "@/assets/js/apiStatus";

const HOSTURL = process.env.VUE_APP_URL;
import {storageData} from "@/assets/js/storage";
import { stat } from "fs";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userInfo: {},
    evaNum: 0,
    isLogin:false,
    stateAgencyName: "",
    qualification:false,
    punishPeople:false,
    appeal:false,
    complaint:false,
    reconsider:false,
    otherComplaint:false,
    confirmInfo:false,
    infoRefused:false,
    peopleAppeal:false,
    timestamp:new Date(),
    stateClassData: {
      groupList: [],
      loadCurriUrl: "",
      classInfo: {}
    },
    stateOrgData: null,
    repeatLogin: {
      flag: false,
      msg: ""
    },
    timer: null,
    stateNoticeList: [],
    stateNoticeNum: 0,
  },
  mutations: {
    updateUserInfo(state, userInfo) {
      // 存本地操作
      storageData.setUserInfo(userInfo);
      // 更新state.userInfo
      state.userInfo = userInfo;
    },
    updateIsLogin(state,val){
      state.isLogin=val
    },
    updateUserImg(state, userImg) {
      state.userInfo.profile_picture = userImg;
    },
    updateEvaNum(state, num) {
      state.evaNum = num;
    },
    updateinfoRefused(state, status) {
      state.infoRefused = status;
    },
    setStoreAgencyName(state, agencyName) {
      state.stateAgencyName = agencyName;
    },
    setStoreClassData(state, {groupList, loadCurriUrl, classInfo}) {
      state.stateClassData = {groupList, loadCurriUrl, classInfo};
    },
    setStoreOrgData(state, orgData) {
      state.stateOrgData = orgData;
    },
    setRepeatLogin(state, obj) {
      state.repeatLogin = obj;
    },
    setHeartBeat(state) {
      heartBeat().then(({data: {status, result}}) => {
        if(status === 0) {
          state.stateNoticeList = result.notice_list;
          state.stateNoticeNum = result.has_notice;
          state.confirmInfo=result.confirmInfo  ;
          state.qualification=result.qualification ;
          state.punishPeople=result.punishPeople ;
          state.peopleAppeal=result.peopleAppeal ;
          state.infoRefused=result.infoRefused ;
          state.appeal=result.appeal ;
          state.complaint=result.complaint ;
          state.otherComplaint=result.otherComplaint ;
          state.reconsider=result.reconsider ;
          state.timestamp=result.timestamp ;
        }
      });
      state.timer = setInterval(() => {
        heartBeat().then(({data: {status, result}}) => {
          if(status === 0) {
            state.stateNoticeList = result.notice_list;
            state.stateNoticeNum = result.has_notice;
            state.confirmInfo=result.confirmInfo  ;
            state.qualification=result.qualification ;
            state.punishPeople=result.punishPeople ;
            state.peopleAppeal=result.peopleAppeal ;
            state.infoRefused=result.infoRefused ;
            state.appeal=result.appeal ;
            state.complaint=result.complaint ;
            state.otherComplaint=result.otherComplaint ;
            state.reconsider=result.reconsider ;
            state.timestamp=result.timestamp ;
          }
        }).catch((err) => {
          console.error(err);
        });
      }, 100000);
    },
    clearHeartBeat(state) {
      clearInterval(state.timer);
      state.stateNoticeList = [];
      state.stateNoticeNum = 0;
      state.confirmInfo=false;
      state.qualification=false;
      state.punishPeople=false;
      state.peopleAppeal=false;
      state.infoRefused=false;
      state.appeal=false;
      state.complaint=false;
      state.otherComplaint=false;
      state.reconsider=false;
    }
  },
  actions: {
    actionStoreClassData({commit}, classId) {
      return new Promise((resolve, rejects) => {
        getClassDetail({
          c_id: classId
        })
          .then(({data}) => {
            if (data.status === correctStatus) {
              const {result: {class_info}} = data
              const {
                moment_picture,
                timetable_picture
              } = class_info;
              commit("setStoreClassData", {
                groupList: [...data.group_list],
                loadCurriUrl: timetable_picture,
                classInfo: {
                  ...class_info,
                  moment_picture: moment_picture && HOSTURL + moment_picture,
                  timetable_picture:
                    timetable_picture && HOSTURL + timetable_picture
                }
              });
            }
            resolve();
          })
          .catch(err => {
            console.info("请求失败", err);
            rejects(err);
          });
      });
    },
    actionStoreOrgData({commit}) {
      return new Promise((resolve, rejects) => {
        getOrganizationInfo()
          .then(({data}) => {
            if (data.status === correctStatus) {
              const {
                result: {organization_info: orgInfo}
              } = data;
              const {profile_picture} = orgInfo;
              commit("setStoreOrgData", {
                ...orgInfo,
                profile_picture: profile_picture && HOSTURL + profile_picture
              });
            }
            resolve();
          })
          .catch(err => {
            console.info("请求失败", err);
            rejects(err);
          });
      });
    },
  },
  getters: {
    getStoreAgencyName: state => state.stateAgencyName,
    getStoreClassData: state => state.stateClassData,
    getStoreOrgData: state => state.stateOrgData,
    getStoreNotice: state => state.stateNoticeList,
    getStoreIsLogin: state => state.isLogin,
  }
});
